import { dcrfClient } from "../../app/api";
import { logger } from "../../app/logging";
import {
    IISOTPEndpoint,
    ICreateISOTPEndpoint
} from "./ISOTPEndpointsSlice";

const wsStream = 'isotpendpoint'

export const fetchAllISOTPEndpointsViaDCRF = () => {
    logger.debug('fetchAllISOTPEndpointsViaDCRF')
    return dcrfClient.list(wsStream)
}

export const patchISOTPEndpointViaDCRF = (id: number, data: any) => {
    logger.debug(`patchISOTPEndpointViaDCRF with id: ${id} - data: ${data}`)
    return dcrfClient.patch(wsStream, id, data)
}

export const createISOTPEndpointViaDCRF = (newEndpoint: ICreateISOTPEndpoint) => {
    logger.debug(`createISOTPEndpointViaDCRF ${newEndpoint.name}`)
    return dcrfClient.create(wsStream, newEndpoint)
}

export const deleteISOTPEndpointViaDCRF = (id: number) => {
    logger.debug(`deleteISOTPEndpointViaDCRF with id: ${id}`)
    return dcrfClient.delete(wsStream, id)
}

export const subscribeToISOTPEndpointChangesViaDCRF = (callback: (scanRun: IISOTPEndpoint, action: string) => void) => {
    logger.debug("subscribeToISOTPEndpointChangesViaDCRF")
    const subscription = dcrfClient.subscribe(wsStream,
        {},
        (scanner, action) => {
            callback(scanner as IISOTPEndpoint, action)
        },
        {
            includeCreateEvents: true,
            requestId: 'subscribeToISOTPEndpointChangesViaDCRF',
            subscribeAction: 'subscribe_to_all_changes',
            unsubscribeAction: 'unsubscribe_from_all_changes',
        }
    )
    // a subscription can be canceled by calling "cancel" on the returned subscription object
    return subscription
}